import {
  FETCH_TELECALLER_LEADS_START,
  FETCH_TELECALLER_LEADS_SUCCESS,
  FETCH_TELECALLER_LEADS_ERROR,
  FETCH_UNRECEIVED_CALL_LEADS_START,
  FETCH_UNRECEIVED_CALL_LEADS_SUCCESS,
  FETCH_UNRECEIVED_CALL_LEADS_ERROR,
} from "../types/telecallerTypes";

const initialState = {
  telecallerLeads: {
    data: [],
    loading: false,
    error: null,
  },
  unreceivedCallLeads: {
    data: [],
    loading: false,
    error: null,
  }
  
};

const telecallerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TELECALLER_LEADS_START:
      return {
        ...state,
        telecallerLeads: { ...state.telecallerLeads, loading: true },
      };

    case FETCH_TELECALLER_LEADS_SUCCESS:
      return {
        ...state,
        telecallerLeads: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_TELECALLER_LEADS_ERROR:
      return {
        ...state,
        telecallerLeads: {
          data: [],
          loading: false,
          error: action.payload,
        },
      };

    // ✅ UNRECEIVED CALLS
    case FETCH_UNRECEIVED_CALL_LEADS_START:
      return {
        ...state,
        unreceivedCallLeads: { ...state.unreceivedCallLeads, loading: true },
      };

    case FETCH_UNRECEIVED_CALL_LEADS_SUCCESS:
      return {
        ...state,
        unreceivedCallLeads: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_UNRECEIVED_CALL_LEADS_ERROR:
      return {
        ...state,
        unreceivedCallLeads: {
          data: [],
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default telecallerReducer;
